export const CalendarFormat = {
    sameDay: 'DD/MM/YYYY',
    nextDay: 'DD/MM/YYYY',
    nextWeek: 'DD/MM/YYYY',
    lastDay: 'DD/MM/YYYY',
    lastWeek: 'DD/MM/YYYY',
    sameElse: 'DD/MM/YYYY'
};
